import { createSelector } from 'reselect';
import { getKaMetlhaFuneralCover } from '.';
import { KMF_COVER_CATEGORIES } from '../../actions/kaMetlhaFuneralCover/types';
export const parentsInLawsRelations = [
    {
        code: 'Mother',
        description: 'Mother',
    },
    {
        code: 'Mother-in-law',
        description: 'Mother-in-law',
    },
    {
        code: 'Father',
        description: 'Father',
    },
    {
        code: 'Father-in-law',
        description: 'Father-in-law',
    },
    {
        code: 'Step father',
        description: 'Step father',
    },
    {
        code: 'Step mother',
        description: 'Step mother',
    },
    {
        code: 'Adoptive father',
        description: 'Adoptive father',
    },
    {
        code: 'Adoptive mother',
        description: 'Adoptive mother',
    },
];
export const extendedFamilyRelations = [
    {
        code: 'aunt',
        description: 'Aunt',
    },
    {
        code: 'Uncle',
        description: 'Uncle',
    },
    {
        code: 'Brother',
        description: 'Brother',
    },
    {
        code: 'Sister',
        description: 'Sister',
    },
    {
        code: 'Brother-in-law',
        description: 'Brother-in-law',
    },
    {
        code: 'Sister-in-law',
        description: 'Sister-in-law',
    },
    {
        code: 'Son-in-law',
        description: 'Son-in-law',
    },
    {
        code: 'Daughter-in-law',
        description: 'Daughter-in-law',
    },
    {
        code: 'Grand-father',
        description: 'Grand-father',
    },
    {
        code: 'Grand-mother',
        description: 'Grand-mother',
    },
    {
        code: 'Grand-son',
        description: 'Grand-son',
    },
    {
        code: 'Grand-daughter',
        description: 'Grand-daughter',
    },
    {
        code: 'Niece',
        description: 'Niece',
    },
    {
        code: 'First cousins',
        description: 'First cousins',
    },
    {
        code: 'Nephew',
        description: 'Nephew',
    },
    {
        code: 'Son',
        description: 'Son',
    },
    {
        code: 'Daughter',
        description: 'Daughter',
    },
    {
        code: 'Ex-husband',
        description: 'Ex-husband',
    },
    {
        code: 'Ex-wife',
        description: 'Ex-wife',
    },
];
const directFamilyRelations = [
    {
        code: 'Child',
        description: 'Child',
    },
    {
        code: 'Spouse',
        description: 'Spouse',
    },
];
export const getQuoteRefernceData = () => ({
    displayCoverCategories: [
        ...directFamilyRelations,
        {
            code: KMF_COVER_CATEGORIES.PARENTS_AND_IN_LAWS,
            description: 'My Parents and Parents In-law',
        },
        {
            code: KMF_COVER_CATEGORIES.EXTENDED_FAMILY,
            description: 'My Extended Family',
        },
    ],
    quoteDisplayCoverCategories: [
        {
            code: KMF_COVER_CATEGORIES.PARENTS_AND_IN_LAWS,
            description: 'My Parents and Parents In-law',
        },
        {
            code: KMF_COVER_CATEGORIES.EXTENDED_FAMILY,
            description: 'My Extended Family',
        },
    ],
    displayParentsandInLaws: parentsInLawsRelations,
    displayExtendedFamilyMembers: extendedFamilyRelations,
    referenceTitles: [
        {
            code: 'Mr.',
            description: 'Mr.',
        },
        {
            code: 'Mrs.',
            description: 'Mrs.',
        },
        {
            code: 'Miss.',
            description: 'Miss.',
        },
    ],
    beneficiaryRelations: [...directFamilyRelations, ...parentsInLawsRelations, ...extendedFamilyRelations],
    yesNoReferenceData: [
        {
            code: 'Yes',
            description: 'Yes',
        },
        {
            code: 'No',
            description: 'No',
        },
    ],
    referenceNationality: [
        { description: 'Afghanistan', code: 'Afghanistan' },
        { description: 'Albania', code: 'Albania' },
        { description: 'Algeria', code: 'Algeria' },
        { description: 'Andorra', code: 'Andorra' },
        { description: 'Angola', code: 'Angola' },
        { description: 'Anguilla', code: 'Anguilla' },
        { description: 'Antigua And Barbuda', code: 'Antigua And Barbuda' },
        { description: 'Argentina', code: 'Argentina' },
        { description: 'Armenia', code: 'Armenia' },
        { description: 'Aruba', code: 'Aruba' },
        { description: 'Jordan', code: 'Jordan' },
        { description: 'Kazakhstan', code: 'Kazakhstan' },
        { description: 'Kenya', code: 'Kenya' },
        { description: 'Kiribati', code: 'Kiribati' },
        { description: 'Korea, Republic (South)', code: 'Korea, Republic (South)' },
        { description: 'Kosovo', code: 'Kosovo' },
        { description: 'Kuwait', code: 'Kuwait' },
        { description: 'Laos', code: 'Laos' },
        { description: 'Latvia', code: 'Latvia' },
        { description: 'Ascension And St-Helena', code: 'Ascension And St-Helena' },
        { description: 'Lebanon', code: 'Lebanon' },
        { description: 'Lesotho', code: 'Lesotho' },
        { description: 'Liberia', code: 'Liberia' },
        { description: 'Libya', code: 'Libya' },
        { description: 'Lithuania', code: 'Lithuania' },
        { description: 'Luxemburg', code: 'Luxemburg' },
        { description: 'Macao', code: 'Macao' },
        { description: 'Macedonia', code: 'Macedonia' },
        { description: 'Madagascar', code: 'Madagascar' },
        { description: 'Malawi', code: 'Malawi' },
        { description: 'Australia', code: 'Australia' },
        { description: 'Malaysia', code: 'Malaysia' },
        { description: 'Maldives', code: 'Maldives' },
        { description: 'Mali', code: 'Mali' },
        { description: 'Malta', code: 'Malta' },
        { description: 'Martinique', code: 'Martinique' },
        { description: 'Mauritania', code: 'Mauritania' },
        { description: 'Mauritius', code: 'Mauritius' },
        { description: 'Mexico', code: 'Mexico' },
        { description: 'Moldova', code: 'Moldova' },
        { description: 'Austria', code: 'Austria' },
        { description: 'Mongolia', code: 'Mongolia' },
        { description: 'Montenegro', code: 'Montenegro' },
        { description: 'Montserrat', code: 'Montserrat' },
        { description: 'Mozambique', code: 'Mozambique' },
        { description: 'Myanmar', code: 'Myanmar' },
        { description: 'Namibia', code: 'Namibia' },
        { description: 'Nauru', code: 'Nauru' },
        { description: 'Nepal', code: 'Nepal' },
        { description: 'Netherlands', code: 'Netherlands' },
        { description: 'Azerbaidjan', code: 'Azerbaidjan' },
        { description: 'Netherlands Antilles', code: 'Netherlands Antilles' },
        { description: 'New Caledonia', code: 'New Caledonia' },
        { description: 'New Zealand', code: 'New Zealand' },
        { description: 'Nicaragua', code: 'Nicaragua' },
        { description: 'Niger', code: 'Niger' },
        { description: 'Nigeria', code: 'Nigeria' },
        { description: 'Niu Island', code: 'Niu Island' },
        { description: 'North Korea', code: 'North Korea' },
        { description: 'Norway', code: 'Norway' },
        { description: 'Oman', code: 'Oman' },
        { description: 'Bahamas', code: 'Bahamas' },
        { description: 'Pakistan', code: 'Pakistan' },
        { description: 'Panama', code: 'Panama' },
        { description: 'Papua New Guinea', code: 'Papua New Guinea' },
        { description: 'Paraguay', code: 'Paraguay' },
        { description: 'Peru', code: 'Peru' },
        { description: 'Philippines', code: 'Philippines' },
        { description: 'Pitcairn Islands', code: 'Pitcairn Islands' },
        { description: 'Poland', code: 'Poland' },
        { description: 'Portugal', code: 'Portugal' },
        { description: 'Qatar', code: 'Qatar' },
        { description: 'Bahrain', code: 'Bahrain' },
        { description: 'Reunion', code: 'Reunion' },
        { description: 'Romania', code: 'Romania' },
        { description: 'Russia', code: 'Russia' },
        { description: 'Rwanda', code: 'Rwanda' },
        { description: 'Samoa', code: 'Samoa' },
        { description: 'Sao Tome And Principe', code: 'Sao Tome And Principe' },
        { description: 'Saudi Arabia', code: 'Saudi Arabia' },
        { description: 'Senegal', code: 'Senegal' },
        { description: 'Serbia', code: 'Serbia' },
        { description: 'Seychelles', code: 'Seychelles' },
        { description: 'Bangladesh', code: 'Bangladesh' },
        { description: 'Sierra Leone', code: 'Sierra Leone' },
        { description: 'Singapore', code: 'Singapore' },
        { description: 'Slovakia', code: 'Slovakia' },
        { description: 'Slovenia', code: 'Slovenia' },
        { description: 'Solomon Islands', code: 'Solomon Islands' },
        { description: 'Somalia', code: 'Somalia' },
        { description: 'South Africa', code: 'South Africa' },
        { description: 'Spain', code: 'Spain' },
        { description: 'Sri Lanka', code: 'Sri Lanka' },
        { description: 'St Kitts And Nevis', code: 'St Kitts And Nevis' },
        { description: 'Barbados', code: 'Barbados' },
        { description: 'St Lucia', code: 'St Lucia' },
        { description: 'St Pierre And Miquelon', code: 'St Pierre And Miquelon' },
        { description: 'St Vincent And The Grenadines', code: 'St Vincent And The Grenadines' },
        { description: 'Sudan', code: 'Sudan' },
        { description: 'South Sudan', code: 'South Sudan' },
        { description: 'Suriname', code: 'Suriname' },
        { description: 'Turks & Caicos Islands', code: 'Turks & Caicos Islands' },
        { description: 'Tuvalu', code: 'Tuvalu' },
        { description: 'Uganda', code: 'Uganda' },
        { description: 'Ukraine', code: 'Ukraine' },
        { description: 'United Arab Emirates', code: 'United Arab Emirates' },
        { description: 'Uruguay', code: 'Uruguay' },
        { description: 'Usa', code: 'Usa' },
        { description: 'Uzbekistan', code: 'Uzbekistan' },
        { description: 'Belize', code: 'Belize' },
        { description: 'Vanuatu', code: 'Vanuatu' },
        { description: 'Vatican', code: 'Vatican' },
        { description: 'Venezuela', code: 'Venezuela' },
        { description: 'Vietnam', code: 'Vietnam' },
        { description: 'Wallis And Futuna Islands', code: 'Wallis And Futuna Islands' },
        { description: 'Yemen', code: 'Yemen' },
        { description: 'Zambia', code: 'Zambia' },
        { description: 'Zimbabwe', code: 'Zimbabwe' },
        { description: 'Benin', code: 'Benin' },
        { description: 'Bermuda', code: 'Bermuda' },
        { description: 'Bhutan', code: 'Bhutan' },
        { description: 'Bolivia', code: 'Bolivia' },
        { description: 'Bosnia Herzegovina', code: 'Bosnia Herzegovina' },
        { description: 'Botswana', code: 'Botswana' },
        { description: 'Brazil', code: 'Brazil' },
        { description: 'British Virgin Island', code: 'British Virgin Island' },
        { description: 'Brunei Darussalam', code: 'Brunei Darussalam' },
        { description: 'Bulgaria', code: 'Bulgaria' },
        { description: 'Burkina Faso', code: 'Burkina Faso' },
        { description: 'Burundi', code: 'Burundi' },
        { description: 'Cambodia', code: 'Cambodia' },
        { description: 'Cameroon', code: 'Cameroon' },
        { description: 'Canada', code: 'Canada' },
        { description: 'Cape Verde', code: 'Cape Verde' },
        { description: 'Cayman Islands', code: 'Cayman Islands' },
        { description: 'Central African Republic', code: 'Central African Republic' },
        { description: 'Chad', code: 'Chad' },
        { description: 'Chile', code: 'Chile' },
        { description: 'China', code: 'China' },
        { description: 'Colombia', code: 'Colombia' },
        { description: 'Comoros', code: 'Comoros' },
        { description: 'Congo', code: 'Congo' },
        { description: 'Cook Islands', code: 'Cook Islands' },
        { description: 'Costa Rica', code: 'Costa Rica' },
        { description: 'Croatia', code: 'Croatia' },
        { description: 'Cuba', code: 'Cuba' },
        { description: 'Cyprus', code: 'Cyprus' },
        { description: 'Czech Republic', code: 'Czech Republic' },
        { description: 'Denmark', code: 'Denmark' },
        { description: 'Djibouti', code: 'Djibouti' },
        { description: 'Dominica', code: 'Dominica' },
        { description: 'Dominican Republic', code: 'Dominican Republic' },
        { description: 'Ecuador', code: 'Ecuador' },
        { description: 'Egypt', code: 'Egypt' },
        { description: 'El Salvador', code: 'El Salvador' },
        { description: 'Equatorial Guinea', code: 'Equatorial Guinea' },
        { description: 'Eritrea', code: 'Eritrea' },
        { description: 'Estonia', code: 'Estonia' },
        { description: 'Ethiopia', code: 'Ethiopia' },
        { description: 'Falkland Islands', code: 'Falkland Islands' },
        { description: 'Faröe Islands', code: 'Faröe Islands' },
        { description: 'Fiji', code: 'Fiji' },
        { description: 'Finland', code: 'Finland' },
        { description: 'France', code: 'France' },
        { description: 'French Guiana', code: 'French Guiana' },
        { description: 'French Polynesia', code: 'French Polynesia' },
        { description: 'Gabon', code: 'Gabon' },
        { description: 'Gambia', code: 'Gambia' },
        { description: 'Georgia', code: 'Georgia' },
        { description: 'Germany', code: 'Germany' },
        { description: 'Ghana', code: 'Ghana' },
        { description: 'Gibraltar', code: 'Gibraltar' },
        { description: 'Great Britain', code: 'Great Britain' },
        { description: 'Greece', code: 'Greece' },
        { description: 'Greenland', code: 'Greenland' },
        { description: 'Grenada', code: 'Grenada' },
        { description: 'Guadeloupe', code: 'Guadeloupe' },
        { description: 'Guatemala', code: 'Guatemala' },
        { description: 'Guinea', code: 'Guinea' },
        { description: 'Guinea-Bissau', code: 'Guinea-Bissau' },
        { description: 'Guyana', code: 'Guyana' },
        { description: 'Haiti', code: 'Haiti' },
        { description: 'Honduras', code: 'Honduras' },
        { description: 'Hong Kong', code: 'Hong Kong' },
        { description: 'Hungary', code: 'Hungary' },
        { description: 'Iceland', code: 'Iceland' },
        { description: 'India', code: 'India' },
        { description: 'Indonesia', code: 'Indonesia' },
        { description: 'Iran', code: 'Iran' },
        { description: 'Iraq', code: 'Iraq' },
        { description: 'Ireland', code: 'Ireland' },
        { description: 'Israel', code: 'Israel' },
        { description: 'Italy', code: 'Italy' },
        { description: 'Ivory Coast', code: 'Ivory Coast' },
        { description: 'Jamaica', code: 'Jamaica' },
        { description: 'Japan', code: 'Japan' },
        { description: 'Eswatini', code: 'Eswatini' },
        { description: 'Sweden', code: 'Sweden' },
        { description: 'Switzerland', code: 'Switzerland' },
        { description: 'Syria', code: 'Syria' },
        { description: 'Taiwan', code: 'Taiwan' },
        { description: 'Belarus', code: 'Belarus' },
        { description: 'Tajikistan', code: 'Tajikistan' },
        { description: 'Tanzania', code: 'Tanzania' },
        { description: 'Thailand', code: 'Thailand' },
        { description: 'Timor-Leste', code: 'Timor-Leste' },
        { description: 'Togo', code: 'Togo' },
        { description: 'Tokelau Islands', code: 'Tokelau Islands' },
        { description: 'Tonga', code: 'Tonga' },
        { description: 'Trinidad And Tobago', code: 'Trinidad And Tobago' },
        { description: 'Tristan Da Cunha', code: 'Tristan Da Cunha' },
        { description: 'Tunisia', code: 'Tunisia' },
        { description: 'Belgium', code: 'Belgium' },
        { description: 'Turkey', code: 'Turkey' },
        { description: 'Turkmenistan', code: 'Turkmenistan' },
    ],
        referenceBirthCountriesUpdated:[
  { code: "01", description: "Afghanistan" },
  { code: "02", description: "Albania" },
  { code: "03", description: "Algeria" },
  { code: "04", description: "Andorra" },
  { code: "05", description: "Angola" },
  { code: "06", description: "Anguilla" },
  { code: "07", description: "Antigua And Barbuda" },
  { code: "08", description: "Argentina" },
  { code: "09", description: "Armenia" },
  { code: "10", description: "Aruba" },
  { code: "11", description: "Ascension And St-Helena" },
  { code: "12", description: "Australia" },
  { code: "13", description: "Austria" },
  { code: "14", description: "Azerbaidjan" },
  { code: "15", description: "Bahamas" },
  { code: "16", description: "Bahrain" },
  { code: "17", description: "Bangladesh" },
  { code: "18", description: "Barbados" },
  { code: "19", description: "Belarus" },
  { code: "20", description: "Belgium" },
  { code: "21", description: "Belize" },
  { code: "22", description: "Benin" },
  { code: "23", description: "Bermuda" },
  { code: "24", description: "Bhutan" },
  { code: "25", description: "Bolivia" },
  { code: "26", description: "Bosnia Herzegovina" },
  { code: "27", description: "Botswana" },
  { code: "28", description: "Brazil" },
  { code: "29", description: "British Virgin Island" },
  { code: "30", description: "Brunei Darussalam" },
  { code: "31", description: "Bulgaria" },
  { code: "32", description: "Burkina Faso" },
  { code: "33", description: "Burundi" },
  { code: "34", description: "Cambodia" },
  { code: "35", description: "Cameroon" },
  { code: "36", description: "Canada" },
  { code: "37", description: "Cape Verde" },
  { code: "38", description: "Cayman Islands" },
  { code: "39", description: "Central African Republic" },
  { code: "40", description: "Chad" },
  { code: "41", description: "Chile" },
  { code: "42", description: "China" },
  { code: "43", description: "Colombia" },
  { code: "44", description: "Comoros" },
  { code: "45", description: "Congo" },
  { code: "46", description: "Cook Islands" },
  { code: "47", description: "Costa Rica" },
  { code: "48", description: "Croatia" },
  { code: "49", description: "Cuba" },
  { code: "50", description: "Cyprus" },
  { code: "51", description: "Czech Republic" },
  { code: "52", description: "Denmark" },
  { code: "53", description: "Djibouti" },
  { code: "54", description: "Dominica" },
  { code: "55", description: "Dominican Republic" },
  { code: "56", description: "Ecuador" },
  { code: "57", description: "Egypt" },
  { code: "58", description: "El Salvador" },
  { code: "59", description: "Equatorial Guinea" },
  { code: "60", description: "Eritrea" },
  { code: "61", description: "Estonia" },
  { code: "62", description: "Ethiopia" },
  { code: "63", description: "Falkland Islands" },
  { code: "64", description: "Faröe Islands" },
  { code: "65", description: "Fiji" },
  { code: "66", description: "Finland" },
  { code: "67", description: "France" },
  { code: "68", description: "French Guiana" },
  { code: "69", description: "French Polynesia" },
  { code: "70", description: "Gabon" },
  { code: "71", description: "Gambia" },
  { code: "72", description: "Georgia" },
  { code: "73", description: "Germany" },
  { code: "74", description: "Ghana" },
  { code: "75", description: "Gibraltar" },
  { code: "76", description: "Great Britain" },
  { code: "77", description: "Greece" },
  { code: "78", description: "Greenland" },
  { code: "79", description: "Grenada" },
  { code: "80", description: "Guadeloupe" },
  { code: "81", description: "Guatemala" },
  { code: "82", description: "Guinea" },
  { code: "83", description: "Guinea-Bissau" },
  { code: "84", description: "Guyana" },
  { code: "85", description: "Haiti" },
  { code: "86", description: "Honduras" },
  { code: "87", description: "Hong Kong" },
  { code: "88", description: "Hungary" },
  { code: "89", description: "Iceland" },
  { code: "90", description: "India" },
  { code: "91", description: "Indonesia" },
  { code: "92", description: "Iran" },
  { code: "93", description: "Iraq" },
  { code: "94", description: "Ireland" },
  { code: "95", description: "Israel" },
  { code: "96", description: "Italy" },
  { code: "97", description: "Ivory Coast" },
  { code: "98", description: "Jamaica" },
  { code: "99", description: "European Commission" },
  { code: "100", description: "Jordan" },
  { code: "101", description: "Kazakhstan" },
  { code: "102", description: "Kenya" },
  { code: "103", description: "Kiribati" },
  { code: "104", description: "Korea, Republic (South)" },
  { code: "105", description: "Kosovo" },
  { code: "106", description: "Kuwait" },
  { code: "107", description: "Kyrgyzstan" },
  { code: "108", description: "Laos" },
  { code: "109", description: "Latvia" },
  { code: "110", description: "Lebanon" },
  { code: "111", description: "Lesotho" },
  { code: "112", description: "Liberia" },
  { code: "113", description: "Libya" },
  { code: "114", description: "Lithuania" },
  { code: "115", description: "Luxemburg" },
  { code: "116", description: "Macao" },
  { code: "117", description: "Macedonia" },
  { code: "118", description: "Madagascar" },
  { code: "119", description: "Malawi" },
  { code: "120", description: "Malaysia" },
  { code: "121", description: "Maldives" },
  { code: "122", description: "Mali" },
  { code: "123", description: "Malta" },
  { code: "124", description: "Martinique" },
  { code: "125", description: "Mauritania" },
  { code: "126", description: "Mauritius" },
  { code: "127", description: "Mayotte" },
  { code: "128", description: "Mexico" },
  { code: "129", description: "Moldova" },
  { code: "130", description: "Mongolia" },
  { code: "131", description: "Montenegro" },
  { code: "132", description: "Montserrat" },
  { code: "133", description: "Morocco" },
  { code: "134", description: "Mozambique" },
  { code: "135", description: "Myanmar" },
  { code: "136", description: "Namibia" },
  { code: "137", description: "Nauru" },
  { code: "138", description: "Nepal" },
  { code: "139", description: "Netherlands" },
  { code: "140", description: "Netherlands Antilles" },
  { code: "141", description: "New Caledonia" },
  { code: "142", description: "New Zealand" },
  { code: "143", description: "Nicaragua" },
  { code: "144", description: "Niger" },
  { code: "145", description: "Nigeria" },
  { code: "146", description: "Niu Island" },
  { code: "147", description: "North Korea" },
  { code: "148", description: "Norway" },
  { code: "149", description: "Oman" },
  { code: "150", description: "Pakistan" },
  { code: "151", description: "Panama" },
  { code: "152", description: "Papua New Guinea" },
  { code: "153", description: "Paraguay" },
  { code: "154", description: "Peru" },
  { code: "155", description: "Philippines" },
  { code: "156", description: "Pitcairn Islands" },
  { code: "157", description: "Poland" },
  { code: "158", description: "Portugal" },
  { code: "159", description: "Qatar" },
  { code: "160", description: "Reunion" },
  { code: "161", description: "Romania" },
  { code: "162", description: "Russia" },
  { code: "163", description: "Rwanda" },
  { code: "164", description: "Samoa" },
  { code: "165", description: "Sao Tome And Principe" },
  { code: "166", description: "Saudi Arabia" },
  { code: "167", description: "Senegal" },
  { code: "168", description: "Serbia" },
  { code: "169", description: "Seychelles" },
  { code: "170", description: "Sierra Leone" },
  { code: "171", description: "Singapore" },
  { code: "172", description: "Slovakia" },
  { code: "173", description: "Slovenia" },
  { code: "174", description: "Solomon Islands" },
  { code: "175", description: "Somalia" },
  { code: "176", description: "South Africa" },
  { code: "177", description: "Spain" },
  { code: "178", description: "Sri Lanka" },
  { code: "179", description: "St Kitts And Nevis" },
  { code: "180", description: "St Lucia" },
  { code: "181", description: "St Pierre And Miquelon" },
  { code: "182", description: "St Vincent And The Grenadines" },
  { code: "183", description: "South Sudan" },
  { code: "184", description: "Suriname" },
  { code: "185", description: "Eswatini" },
  { code: "186", description: "Sweden" },
  { code: "187", description: "Switzerland" },
  { code: "188", description: "Syria" },
  { code: "189", description: "Taiwan" },
  { code: "190", description: "Tajikistan" },
  { code: "191", description: "Tanzania" },
  { code: "192", description: "Thailand" },
  { code: "193", description: "Timor-Leste" },
  { code: "194", description: "Togo" },
  { code: "195", description: "Tokelau Islands" },
  { code: "196", description: "Tonga" },
  { code: "197", description: "Trinidad And Tobago" },
  { code: "198", description: "Tristan Da Cunha" },
  { code: "199", description: "Tunisia" },
  { code: "200", description: "Turkey" },
  { code: "201", description: "Turkmenistan" },
  { code: "202", description: "Turks & Caicos Islands" },
  { code: "203", description: "Tuvalu" },
  { code: "204", description: "Uganda" },
  { code: "205", description: "Ukraine" },
  { code: "206", description: "United Arab Emirates" },
  { code: "207", description: "Uruguay" },
  { code: "208", description: "United States Of America" },
  { code: "209", description: "Uzbekistan" },
  { code: "210", description: "Vanuatu" },
  { code: "211", description: "Vatican" },
  { code: "212", description: "Venezuela" },
  { code: "213", description: "Vietnam" },
  { code: "214", description: "Wallis And Futuna Islands" },
  { code: "215", description: "Yemen" },
  { code: "216", description: "Zambia" },
  { code: "217", description: "Zimbabwe" },
  { code: "218", description: "Japan" },
  { code: "219", description: "Gulf Co-operation Council" },
  { code: "220", description: "UK" }
],

    referenceBirthCountries: [
        {code: 'Afghanistan', description: 'Afghanistan'},
        {code: 'Albania', description: 'Albania'},
        {code: 'Algeria', description: 'Algeria'},
        {code: 'Andorra', description: 'Andorra'},
        {code: 'Angola', description: 'Angola'},
        {code: 'Anguilla', description: 'Anguilla'},
        {code: 'Antigua And Barbuda', description: 'Antigua And Barbuda'},
        {code: 'Argentina', description: 'Argentina'},
        {code: 'Armenia', description: 'Armenia'},
        {code: 'Aruba', description: 'Aruba'},
        {code: 'Jordan', description: 'Jordan'},
        {code: 'Kazakhstan', description: 'Kazakhstan'},
        {code: 'Kenya', description: 'Kenya'},
        {code: 'Kiribati', description: 'Kiribati'},
        {code: 'Korea, Republic (South)', description: 'Korea, Republic (South)'},
        {code: 'Kosovo', description: 'Kosovo'},
        {code: 'Kuwait', description: 'Kuwait'},
        {code: 'Kyrgyzstan', description: 'Kyrgyzstan'},
        {code: 'Laos', description: 'Laos'},
        {code: 'Latvia', description: 'Latvia'},
        {code: 'Ascension And St-Helena', description: 'Ascension And St-Helena'},
        {code: 'Lebanon', description: 'Lebanon'},
        {code: 'Lesotho', description: 'Lesotho'},
        {code: 'Liberia', description: 'Liberia'},
        {code: 'Libya', description: 'Libya'},
        {code: 'Lithuania', description: 'Lithuania'},
        {code: 'Luxemburg', description: 'Luxemburg'},
        {code: 'Macao', description: 'Macao'},
        {code: 'Macedonia', description: 'Macedonia'},
        {code: 'Madagascar', description: 'Madagascar'},
        {code: 'Malawi', description: 'Malawi'},
        {code: 'Australia', description: 'Australia'},
        {code: 'Malaysia', description: 'Malaysia'},
        {code: 'Maldives', description: 'Maldives'},
        {code: 'Mali', description: 'Mali'},
        {code: 'Malta', description: 'Malta'},
        {code: 'Martinique', description: 'Martinique'},
        {code: 'Mauritania', description: 'Mauritania'},
        {code: 'Mauritius', description: 'Mauritius'},
        {code: 'Mayotte', description: 'Mayotte'},
        {code: 'Mexico', description: 'Mexico'},
        {code: 'Moldova', description: 'Moldova'},
        {code: 'Austria', description: 'Austria'},
        {code: 'Mongolia', description: 'Mongolia'},
        {code: 'Montenegro', description: 'Montenegro'},
        {code: 'Montserrat', description: 'Montserrat'},
        {code: 'Morocco', description: 'Morocco'},
        {code: 'Mozambique', description: 'Mozambique'},
        {code: 'Myanmar', description: 'Myanmar'},
        {code: 'Namibia', description: 'Namibia'},
        {code: 'Nauru', description: 'Nauru'},
        {code: 'Nepal', description: 'Nepal'},
        {code: 'Netherlands', description: 'Netherlands'},
        {code: 'Azerbaidjan', description: 'Azerbaidjan'},
        {code: 'Netherlands Antilles', description: 'Netherlands Antilles'},
        {code: 'New Caledonia', description: 'New Caledonia'},
        {code: 'New Zealand', description: 'New Zealand'},
        {code: 'Nicaragua', description: 'Nicaragua'},
        {code: 'Niger', description: 'Niger'},
        {code: 'Nigeria', description: 'Nigeria'},
        {code: 'Niu Island', description: 'Niu Island'},
        {code: 'North Korea', description: 'North Korea'},
        {code: 'Norway', description: 'Norway'},
        {code: 'Oman', description: 'Oman'},
        {code: 'Bahamas', description: 'Bahamas'},
        {code: 'Pakistan', description: 'Pakistan'},
        {code: 'Panama', description: 'Panama'},
        {code: 'Papua New Guinea', description: 'Papua New Guinea'},
        {code: 'Paraguay', description: 'Paraguay'},
        {code: 'Peru', description: 'Peru'},
        {code: 'Philippines', description: 'Philippines'},
        {code: 'Pitcairn Islands', description: 'Pitcairn Islands'},
        {code: 'Poland', description: 'Poland'},
        {code: 'Portugal', description: 'Portugal'},
        {code: 'Qatar', description: 'Qatar'},
        {code: 'Bahrain', description: 'Bahrain'},
        {code: 'Reunion', description: 'Reunion'},
        {code: 'Romania', description: 'Romania'},
        {code: 'Russia', description: 'Russia'},
        {code: 'Rwanda', description: 'Rwanda'},
        {code: 'Samoa', description: 'Samoa'},
        {code: 'Sao Tome And Principe', description: 'Sao Tome And Principe'},
        {code: 'Saudi Arabia', description: 'Saudi Arabia'},
        {code: 'Senegal', description: 'Senegal'},
        {code: 'Serbia', description: 'Serbia'},
        {code: 'Seychelles', description: 'Seychelles'},
        {code: 'Bangladesh', description: 'Bangladesh'},
        {code: 'Sierra Leone', description: 'Sierra Leone'},
        {code: 'Singapore', description: 'Singapore'},
        {code: 'Slovakia', description: 'Slovakia'},
        {code: 'Slovenia', description: 'Slovenia'},
        {code: 'Solomon Islands', description: 'Solomon Islands'},
        {code: 'Somalia', description: 'Somalia'},
        {code: 'South Africa', description: 'South Africa'},
        {code: 'Spain', description: 'Spain'},
        {code: 'Sri Lanka', description: 'Sri Lanka'},
        {code: 'St Kitts And Nevis', description: 'St Kitts And Nevis'},
        {code: 'Barbados', description: 'Barbados'},
        {code: 'St Lucia', description: 'St Lucia'},
        {code: 'St Pierre And Miquelon', description: 'St Pierre And Miquelon'},
        {code: 'St Vincent And The Grenadines', description: 'St Vincent And The Grenadines'},
        {code: 'South Sudan ', description: 'South Sudan '},
        {code: 'Suriname', description: 'Suriname'},
        {code: 'Eswatini', description: 'Eswatini'},
        {code: 'Sweden', description: 'Sweden'},
        {code: 'Switzerland', description: 'Switzerland'},
        {code: 'Syria', description: 'Syria'},
        {code: 'Taiwan', description: 'Taiwan'},
        {code: 'Belarus', description: 'Belarus'},
        {code: 'Tajikistan', description: 'Tajikistan'},
        {code: 'Tanzania', description: 'Tanzania'},
        {code: 'Thailand', description: 'Thailand'},
        {code: 'Timor-Leste', description: 'Timor-Leste'},
        {code: 'Togo', description: 'Togo'},
        {code: 'Tokelau Islands', description: 'Tokelau Islands'},
        {code: 'Tonga', description: 'Tonga'},
        {code: 'Trinidad And Tobago', description: 'Trinidad And Tobago'},
        {code: 'Tristan Da Cunha', description: 'Tristan Da Cunha'},
        {code: 'Tunisia', description: 'Tunisia'},
        {code: 'Belgium', description: 'Belgium'},
        {code: 'Turkey', description: 'Turkey'},
        {code: 'Turkmenistan', description: 'Turkmenistan'},
        {code: 'Turks & Caicos Islands', description: 'Turks & Caicos Islands'},
        {code: 'Tuvalu', description: 'Tuvalu'},
        {code: 'Uganda', description: 'Uganda'},
        {code: 'Ukraine', description: 'Ukraine'},
        {code: 'United Arab Emirates', description: 'United Arab Emirates'},
        {code: 'Uruguay', description: 'Uruguay'},
        {code: 'United States Of America', description: 'United States Of America'},
        {code: 'Uzbekistan', description: 'Uzbekistan'},
        {code: 'Belize', description: 'Belize'},
        {code: 'Vanuatu', description: 'Vanuatu'},
        {code: 'Vatican', description: 'Vatican'},
        {code: 'Venezuela', description: 'Venezuela'},
        {code: 'Vietnam', description: 'Vietnam'},
        {code: 'Wallis And Futuna Islands', description: 'Wallis And Futuna Islands'},
        {code: 'Yemen', description: 'Yemen'},
        {code: 'Zambia', description: 'Zambia'},
        {code: 'Zimbabwe', description: 'Zimbabwe'},
        {code: 'Japan', description: 'Japan'},
        {code: 'Gulf Co-operation Council', description: 'Gulf Co-operation Council'},
        {code: 'Benin', description: 'Benin'},
        {code: 'UK', description: 'UK'},
        {code: 'Bermuda', description: 'Bermuda'},
        {code: 'Bhutan', description: 'Bhutan'},
        {code: 'Bolivia', description: 'Bolivia'},
        {code: 'Bosnia Herzegovina', description: 'Bosnia Herzegovina'},
        {code: 'Botswana', description: 'Botswana'},
        {code: 'Brazil', description: 'Brazil'},
        {code: 'British Virgin Island', description: 'British Virgin Island'},
        {code: 'Brunei Darussalam', description: 'Brunei Darussalam'},
        {code: 'Bulgaria', description: 'Bulgaria'},
        {code: 'Burkina Faso', description: 'Burkina Faso'},
        {code: 'Burundi', description: 'Burundi'},
        {code: 'Cambodia', description: 'Cambodia'},
        {code: 'Cameroon', description: 'Cameroon'},
        {code: 'Canada', description: 'Canada'},
        {code: 'Cape Verde', description: 'Cape Verde'},
        {code: 'Cayman Islands', description: 'Cayman Islands'},
        {code: 'Central African Republic', description: 'Central African Republic'},
        {code: 'Chad', description: 'Chad'},
        {code: 'Chile', description: 'Chile'},
        {code: 'China', description: 'China'},
        {code: 'Colombia', description: 'Colombia'},
        {code: 'Comoros', description: 'Comoros'},
        {code: 'Congo', description: 'Congo'},
        {code: 'Cook Islands', description: 'Cook Islands'},
        {code: 'Costa Rica', description: 'Costa Rica'},
        {code: 'Croatia', description: 'Croatia'},
        {code: 'Cuba', description: 'Cuba'},
        {code: 'Cyprus', description: 'Cyprus'},
        {code: 'Czech Republic', description: 'Czech Republic'},
        {code: 'Denmark', description: 'Denmark'},
        {code: 'Djibouti', description: 'Djibouti'},
        {code: 'Dominica', description: 'Dominica'},
        {code: 'Dominican Republic', description: 'Dominican Republic'},
        {code: 'Ecuador', description: 'Ecuador'},
        {code: 'Egypt', description: 'Egypt'},
        {code: 'El Salvador', description: 'El Salvador'},
        {code: 'Equatorial Guinea', description: 'Equatorial Guinea'},
        {code: 'Eritrea', description: 'Eritrea'},
        {code: 'Estonia', description: 'Estonia'},
        {code: 'Ethiopia', description: 'Ethiopia'},
        {code: 'Falkland Islands', description: 'Falkland Islands'},
        {code: 'Faröe Islands', description: 'Faröe Islands'},
        {code: 'Fiji', description: 'Fiji'},
        {code: 'Finland', description: 'Finland'},
        {code: 'France', description: 'France'},
        {code: 'French Guiana', description: 'French Guiana'},
        {code: 'French Polynesia', description: 'French Polynesia'},
        {code: 'Gabon', description: 'Gabon'},
        {code: 'Gambia', description: 'Gambia'},
        {code: 'Georgia', description: 'Georgia'},
        {code: 'Germany', description: 'Germany'},
        {code: 'Ghana', description: 'Ghana'},
        {code: 'Gibraltar', description: 'Gibraltar'},
        {code: 'Great Britain', description: 'Great Britain'},
        {code: 'Greece', description: 'Greece'},
        {code: 'Greenland', description: 'Greenland'},
        {code: 'Grenada', description: 'Grenada'},
        {code: 'Guadeloupe', description: 'Guadeloupe'},
        {code: 'Guatemala', description: 'Guatemala'},
        {code: 'Guinea', description: 'Guinea'},
        {code: 'Guinea-Bissau', description: 'Guinea-Bissau'},
        {code: 'Guyana', description: 'Guyana'},
        {code: 'Haiti', description: 'Haiti'},
        {code: 'Honduras', description: 'Honduras'},
        {code: 'Hong Kong', description: 'Hong Kong'},
        {code: 'Hungary', description: 'Hungary'},
        {code: 'Iceland', description: 'Iceland'},
        {code: 'India', description: 'India'},
        {code: 'Indonesia', description: 'Indonesia'},
        {code: 'Iran', description: 'Iran'},
        {code: 'Iraq', description: 'Iraq'},
        {code: 'Ireland', description: 'Ireland'},
        {code: 'Israel', description: 'Israel'},
        {code: 'Italy', description: 'Italy'},
        {code: 'Ivory Coast', description: 'Ivory Coast'},
        {code: 'Jamaica', description: 'Jamaica'},
        {code: 'European Commission', description: 'European Commission'}
    ],
          
    referenceHearAboutUs: [
        {
            code: 'online',
            description: 'Online',
        },
        {
            code: 'onRadio',
            description: 'On radio',
        },
        {
            code: 'onTv',
            description: 'On Tv',
        },
        {
            code: 'fromBillboard',
            description: 'From a billboard',
        },
        {
            code: 'fromSomeone',
            description: 'From someone I know',
        },
        {
            code: 'omEmployee',
            description: 'Old mutual employee',
        },
        {
            code: 'broker',
            description: 'Broker/Agent',
        },
        {
            code: 'other',
            description: 'Other',
        },
    ],
    referenceOnlinePlatform: [
        {
            code: 'facebook',
            description: 'Facebook',
        },
        {
            code: 'linkedIn',
            description: 'LinkedIn',
        },
        {
            code: 'twitter/X',
            description: 'Twitter/X',
        },
        {
            code: 'youTube',
            description: 'YouTube',
        },
        {
            code: 'googleSearch',
            description: 'Google Search',
        },
    ],
    debitDayReferenceData: [
        { value: 1, label: '1' },
        { value: 2, label: '2' },
        { value: 3, label: '3' },
        { value: 4, label: '4' },
        { value: 5, label: '5' },
        { value: 6, label: '6' },
        { value: 7, label: '7' },
        { value: 8, label: '8' },
        { value: 9, label: '9' },
        { value: 10, label: '10' },
        { value: 11, label: '11' },
        { value: 12, label: '12' },
        { value: 13, label: '13' },
        { value: 14, label: '14' },
        { value: 15, label: '15' },
        { value: 16, label: '16' },
        { value: 17, label: '17' },
        { value: 18, label: '18' },
        { value: 19, label: '19' },
        { value: 20, label: '20' },
        { value: 21, label: '21' },
        { value: 22, label: '22' },
        { value: 23, label: '23' },
        { value: 24, label: '24' },
        { value: 25, label: '25' },
        { value: 26, label: '26' },
        { value: 27, label: '27' },
        { value: 28, label: '28' },
        { value: 29, label: '29' },
        { value: 30, label: '30' },
        { value: 31, label: '31' },
    ],
});

export const getReferenceData = createSelector(
    getKaMetlhaFuneralCover,
    (kaMetlhaFuneralCover) => kaMetlhaFuneralCover.referenceData
);

const getStateData = (feild) => createSelector(getReferenceData, (referenceData) => referenceData[feild]);

export const getBanksReferenceData = getStateData('banks');
export const getBranchCodesReferenceData = getStateData('branchCodes');
export const getApiDetails = getStateData('apiDetails');
export const getPurchaseResponse = getStateData('purchaseServiceResponse');
export const getTermsAndConditions = createSelector(
    getReferenceData,
    (referenceData) => referenceData.termsandConditions
);

export const getQuoteResponse = getStateData('quoteResponese');
export const getAgentInfo = getStateData('agentInfo');
export const isAgentCodeInvalid = createSelector(
  getAgentInfo,
  (agentInfo) => agentInfo?.data?.agentExists === 'NO');

export const isAgentCodeValue = createSelector(
  getAgentInfo,
  (agentInfo) => agentInfo?.data?.agentCode);

  export const isAgentCodeLoading = createSelector(
  getApiDetails,
  (apiDetails) => apiDetails?.name === 'agentService');